import { StoreOptionsPageSchema, type StoreOption, hrShiftConflictRefSchema } from '@easyflow/shared';
import { z } from 'zod';
import { apiClient, isApiError } from './api';
import { resolveApiErrorMessage } from './api-error-message';

/** Il selettore non deve scambiare un errore o una prima pagina per l'intero elenco. */
export async function loadActiveHrStores(): Promise<StoreOption[]> {
  const stores: StoreOption[] = [];
  let page = 1;
  for (;;) {
    const res = await apiClient.get(`/stores?page=${page}&limit=100`).catch((err: unknown) => {
      if (isApiError(err) && typeof err.status === 'number') throw new Error(resolveApiErrorMessage(err.data, err.status));
      throw err;
    });
    if (!res.success) throw new Error(res.error || 'Impossibile caricare le sedi');
    const data = StoreOptionsPageSchema.parse(res.data);
    if (data.pagination.page !== page) throw new Error('Paginazione sedi non valida');
    stores.push(...data.items.filter(s => s.status === 'active'));
    if (page >= data.pagination.totalPages) return stores;
    if (data.items.length === 0) throw new Error('Elenco sedi incompleto');
    page++;
  }
}

const conflictBodySchema = z.object({ conflicts: z.array(hrShiftConflictRefSchema).optional() });
export function describeHrShiftConflict(err: unknown): string | null {
  if (!isApiError(err) || err.status !== 409) return null;
  const body = conflictBodySchema.safeParse(err.data);
  const reasons = body.success ? body.data.conflicts?.map(c => c.type_label).filter(Boolean) : [];
  if (reasons?.length) return reasons.join(', ');
  return resolveApiErrorMessage(err.data, 409);
}
